import { zoom, zoomIdentity } from "d3-zoom";
import { ref, watch } from "vue";
import { select } from "d3-selection";
// if element is draggable it may implement its own drag handler,
// but d3zoom would call preventDefault
const filter = (event) => {
    const preventZoom = event.target.classList.contains("prevent-zoom");
    return !preventZoom;
};
export function useD3Zoom(k, minZoom, maxZoom, targetRef, scroll, initialPan = { x: 0, y: 0 }) {
    const transform = ref({ x: initialPan.x, y: initialPan.y, k: k });
    const d3Zoom = zoom().filter(filter).scaleExtent([minZoom, maxZoom]);
    watch(targetRef, () => {
        if (targetRef.value) {
            const d3Selection = select(targetRef.value).call(d3Zoom);
            const updatedTransform = zoomIdentity
                .translate(transform.value.x, transform.value.y)
                .scale(transform.value.k);
            d3Zoom.transform(d3Selection, updatedTransform);
        }
        d3Zoom.on("zoom", (event) => {
            transform.value = event.transform;
        });
        d3Zoom.on("start", (event) => {
            transform.value = event.transform;
        });
        d3Zoom.on("end", (event) => {
            transform.value = event.transform;
        });
    });
    function setZoom(k) {
        if (targetRef.value) {
            const d3Selection = select(targetRef.value).call(d3Zoom);
            d3Zoom.scaleTo(d3Selection, k);
        }
    }
    function panBy(panBy) {
        if (targetRef.value) {
            const d3Selection = select(targetRef.value).call(d3Zoom);
            d3Zoom.translateBy(d3Selection, panBy.x, panBy.y);
        }
    }
    function moveTo(coordinate) {
        if (targetRef.value) {
            const d3Selection = select(targetRef.value).call(d3Zoom);
            d3Zoom.translateTo(d3Selection, coordinate.x, coordinate.y);
        }
    }
    return { transform, setZoom, panBy, moveTo };
}
